import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PaymentVerification } from 'src/app/demo/models/payment-verification';
import { PaymentVerificationsService } from 'src/app/demo/service/payment-verifications.service';
import { PaymentVerificationConfirmComponent } from '../../payment-verification-confirm/payment-verification-confirm.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ProgressLoaderService } from 'src/app/demo/service/progress-loader.service';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { CamelCasePipe } from 'src/app/demo/pipes/camel-case.pipe';
import { NgxTranslateModule } from 'src/app/translate.module';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/demo/service/language.service';
import { languages } from 'src/app/demo/constants/languages';
import { FormatCapitalizedConstantsService } from 'src/app/demo/service/format-capitalized-constants.service';
import {
    ProgressSpinner,
    ProgressSpinnerModule,
} from 'primeng/progressspinner';
@Component({
    selector: 'app-payment-verification-detail',
    standalone: true,
    imports: [
        CommonModule,
        CardModule,
        ButtonModule,
        ProgressSpinnerModule,
        NgxTranslateModule,
        NgxExtendedPdfViewerModule,
        TableModule,
        TooltipModule,
        CamelCasePipe,
    ],
    templateUrl: './payment-verification-detail.component.html',
    styleUrl: './payment-verification-detail.component.scss',
})
export class PaymentVerificationDetailComponent {
    verification!: PaymentVerification;
    ref: DynamicDialogRef | undefined;
    blobUrl: SafeResourceUrl | null = null;
    languages: any[] = languages;
    selectedLanguage!: string;

    loadingPOP: boolean = false;

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translateService.use(language);
        this.languageService.setLanguage(language);
    }

    constructor(
        private dialogService: DialogService,
        private messageService: MessageService,
        private paymentsVerificationService: PaymentVerificationsService,
        private route: ActivatedRoute,
        private progressLoader: ProgressLoaderService,
        private router: Router,
        private sanitizer: DomSanitizer,
        private translateService: TranslateService,
        private languageService: LanguageService,
        private formatService: FormatCapitalizedConstantsService
    ) {}

    ngOnInit() {
        this.fetchVerificationByPurchaseOrder();
        this.initializeLocale();
    }

    fetchVerificationId(): string {
        let returnId = '';
        this.route.paramMap.subscribe((params) => {
            returnId = params.get('id') || '';
        });
        return returnId;
    }

    formatText(value: string): string {
        return this.formatService.formatConstantToNormalText(value);
    }

    fetchVerificationByPurchaseOrder() {
        this.progressLoader.show();
        this.paymentsVerificationService
            .getPaymentVerificationByPurchaseOrderId(this.fetchVerificationId())
            .subscribe({
                next: (value) => {
                    this.progressLoader.hide();
                    this.verification = value;
                    this.renderPop();
                },
                error: (err) => {
                    this.progressLoader.hide();
                },
            });
    }

    showConfirmDialog(
        paymentVerification: PaymentVerification,
        action: string
    ) {
        const verificationData = {
            verificationDetail: paymentVerification,
            action: action,
        };
        this.ref = this.dialogService.open(
            PaymentVerificationConfirmComponent,
            {
                header: '',
                contentStyle: { overflow: 'visible' },
                baseZIndex: 10000,
                maximizable: false,
                data: verificationData,
            }
        );
    }

    closePage() {
        this.router.navigate(['/home/payment-verifications']);
    }

    downloadPop() {
        let documentId = this.verification.proofOfPayment.id;
        this.paymentsVerificationService
            .getProofOfPaymentDocument(documentId)
            .subscribe((res) => {
                let blob: Blob = res.body as Blob;
                let url = window.URL.createObjectURL(blob);

                let a = document.createElement('a');
                a.download = this.verification?.payment?.reference
                    .concat('_')
                    .concat(this.verification.proofOfPayment.originalFileName);
                a.href = url;
                a.click();
            });
    }

    renderPop() {
        this.loadingPOP = true;
        let documentId = this.verification.proofOfPayment.id;
        this.paymentsVerificationService
            .getProofOfPaymentDocument(documentId)
            .subscribe((res) => {
                this.loadingPOP = false;
                let blobItem = null;
                if (
                    this.verification.proofOfPayment.mimeType ===
                    'application/pdf'
                ) {
                    blobItem = new Blob([res.body], {
                        type: 'application/pdf',
                    });
                } else if (
                    this.verification.proofOfPayment.mimeType === 'image/png'
                ) {
                    blobItem = new Blob([res.body], { type: 'image/png' });
                } else if (
                    this.verification.proofOfPayment.mimeType === 'image/jpeg'
                ) {
                    blobItem = new Blob([res.body], { type: 'image/jpeg' });
                } else {
                    blobItem = new Blob([res.body], {
                        type: 'application/octet-stream',
                    });
                }
                const blobUrl = URL.createObjectURL(blobItem);
                this.blobUrl =
                    this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
            });
    }
}
